var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventRole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 15.6V14.4H1.212L1.2 19.2C1.2 20.532 2.268 21.6 3.6 21.6H20.4C21.732 21.6 22.8 20.532 22.8 19.2V14.4H14.4V15.6H9.6ZM21.6 4.8H16.788V2.4L14.388 0H9.588L7.188 2.4V4.8H2.4C1.08 4.8 0 5.88 0 7.2V10.8C0 12.132 1.068 13.2 2.4 13.2H9.6V10.8H14.4V13.2H21.6C22.92 13.2 24 12.12 24 10.8V7.2C24 5.88 22.92 4.8 21.6 4.8ZM14.4 4.8H9.6V2.4H14.4V4.8Z",
    fill: "#3C91D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventRole);
export default __webpack_public_path__ + "static/media/event_role.c2a36de3d4ea1613f30fae231a02f23c.svg";
export { ForwardRef as ReactComponent };